<div class="map-wrapper" [class.show-floors]="mapPageView">

  <div class="floors" *ngIf="mapPageView">
    <div class="arrows">
      <span [attr.disabled]="this.selectedFloor === 0" class="circle-icon" (click)="selectFloor(-1)">
        <img [src]="'./assets/images/arrow_left.svg'" alt="left_arrow" />
      </span>
      <span [attr.disabled]="this.selectedFloor === this.floors.length -1" class="circle-icon" (click)="selectFloor(1)">
        <img [src]="'./assets/images/arrow_right.svg'" alt="right_arrow" />
      </span>
    </div>
    <span class="description">
      <span class="floor-name">
        {{ this.floors[this.selectedFloor]?.floorCode }}
      </span>
      <span>|</span>
      <span class="floors-counter">
        {{this.floors.length}}
        &nbsp;
        {{ (
        "PAGES.ALLOCATION.FLOORS.COUNTER." +
        (this.floors.length === 1 ?
        "0":"1")
        ) | translate }}
      </span>
    </span>
  </div>

  <div id="image" class="image-wrapper">

  </div>
</div>
